import {useDispatch} from 'react-redux';
import {setHalloweenModal} from '../../../../reducers/app/actions';
import Friends from './friends';
import Self from './self';

export default () => {
    const dispatch = useDispatch();

    return (
        <div className="how">
            <div className="title">How to get tickets</div>
            <div className="friends" onClick={e => dispatch(setHalloweenModal('friends'))}>
                <div className="content">
                    <div className="title">More tickets with friends</div>
                    <div className="text">Invite a friend with your referral link. When he makes a $40 deposits, you will both receive tickets.</div>
                </div>
                <Friends />
            </div>

            <div className="self"  onClick={e => dispatch(setHalloweenModal('deposits'))}>
                <div className="content">
                    <div className="title">Get tickets for a deposit</div>
                    <div className="text">For every $40 deposit you receive a ticket.</div>
                </div>
                <Self />
            </div>
        </div>    
    )
}